import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Input } from 'antd-v5';
import { Link } from 'react-router-dom';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';
import PhoneInput from '../../../../../CustomizedAntDesign/PhoneInput';

export const StoreDetails = () => {
  return (
    <SettingsContent icon={<FontAwesomeIcon icon={['far', 'store']} />} title="Store Details">
      <DescriptionBox
        style={{ marginBottom: 8 }}
        className="w-100-P"
        title="Store Name"
        description="How does your team refer to this location?"
        input={
          <Form.Item name="name" style={{ marginBottom: 0 }}>
            <Input
              style={{ width: '267px' }}
              placeholder="Store Name"
              rules={[{ required: true, message: 'Store Name is required' }]}
            />
          </Form.Item>
        }
      />
      <DescriptionBox
        style={{ marginBottom: 8 }}
        className="w-100-P"
        title="Point of Sale Reference Number"
        description="The alphanumerical value that the Point of Sale runtime uses to identify your store."
        input={
          <Form.Item name="pos_ref_num" style={{ marginBottom: 0 }}>
            <Input style={{ width: '267px' }} placeholder="Point of Sale Reference Number" />
          </Form.Item>
        }
      />
      <DescriptionBox
        style={{ marginBottom: 8 }}
        className="w-100-P"
        title="Store Address"
        description="Where is your store located?"
        input={
          <div>
            <Form.Item name="address_1" style={{ marginBottom: 8 }}>
              <Input style={{ width: '267px' }} placeholder="Store Address" />
            </Form.Item>
            <Form.Item name="address_2" style={{ marginBottom: 8 }}>
              <Input style={{ width: '267px' }} placeholder="Store Address" />
            </Form.Item>
            <Form.Item name="city" style={{ marginBottom: 8 }}>
              <Input style={{ width: '267px' }} placeholder="Store Address" />
            </Form.Item>
            <div className="flex-row-spacebetween-nowrap">
              <Form.Item name="state" style={{ marginBottom: 8 }}>
                <Input style={{ width: '125px' }} placeholder="State" />
              </Form.Item>
              <Form.Item name="postal_code" style={{ marginBottom: 8 }}>
                <Input style={{ width: '125px' }} placeholder="Postal Code" />
              </Form.Item>
            </div>
          </div>
        }
      />
      <DescriptionBox
        style={{ marginBottom: 8 }}
        className="w-100-P"
        title="Store Phone Number"
        description="Where can clients reach you by phone?"
        input={
          <Form.Item
            name="phone_number"
            style={{ marginBottom: 0 }}
            validateTrigger="onSubmit"
            rules={[
              () => ({
                validator(rule, value) {
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (value && ((!value?.phoneNumber && !value?.areaCode) || value?.valid())) {
                    return Promise.resolve();
                  }
                  return Promise.reject('The inserted phone number  is not valid !');
                },
              }),
            ]}
          >
            <PhoneInput style={{ width: '267px' }} placeholder="Store Phone Number" country="us" />
          </Form.Item>
        }
      />
      <DescriptionBox
        style={{ marginBottom: 8 }}
        className="w-100-P"
        title="Phone Number for SMS"
        description="This is the number clients will see when you send a text. Can only be changed by Clientbook."
        input={
          <Form.Item name="sms_number" style={{ marginBottom: 0 }}>
            <PhoneInput style={{ width: '267px' }} placeholder="Phone Number for SMS" disabled />
          </Form.Item>
        }
      />
      <DescriptionBox
        style={{ marginBottom: 8 }}
        className="w-100-P"
        title="Google Review Link"
        description={
          <>
            When you send a review link to a client, what URL do you use? Go to{' '}
            <Link to="/Help/integrations">Integrations</Link> to set up Google Reviews Reviews
          </>
        }
        input={
          <Form.Item name="review_link" style={{ marginBottom: 0 }}>
            <Input style={{ width: '267px' }} placeholder="Google Review Link" />
          </Form.Item>
        }
      />
      <DescriptionBox
        className="w-100-P"
        title="Weekly Clientelling Goal"
        description="The number of unique daily client contacts you want your store to achieve per week. If left blank, your goal will default to the sum total of all the store associates’ daily goals X 5 (average number of days in a work week)."
        input={
          <Form.Item name="weekly_contact_goal" style={{ marginBottom: 0 }}>
            <Input style={{ width: '267px' }} placeholder="Set a Weekly Goal" />
          </Form.Item>
        }
      />
    </SettingsContent>
  );
};
